export const testimonials = [
  {
    name: 'Laura M.',
    role: 'Physiotherapist, 36 — Private Practice',
    initials: 'LM',
    quote:
      'Almost half of my caseload is low back pain, and I was rebuilding sessions from scratch every week. Volume 01 gave me a clear starting point: pelvic tilts, marching, bridges and sit-to-stands already dosed and organized. My first sessions now take minutes to plan.',
  },
  {
    name: 'Daniel R.',
    role: 'Physical Therapist, 44 — Orthopedic Clinic',
    initials: 'DR',
    quote:
      'What I value most is the strength volume. Romanian deadlifts, goblet box squats and farmer carries come with sets, reps, rest and progressions, so I can move patients from basic control to real loading without guessing the next step.',
  },
  {
    name: 'Carolina V.',
    role: 'Kinesiologist, 39 — Spine Rehabilitation',
    initials: 'CV',
    quote:
      'The regression and progression library is gold for my patients with limited tolerance. When an exercise is too demanding, I have an easier option ready, and when they improve, the next level is already on the page.',
  },
  {
    name: 'Michael T.',
    role: 'Physical Therapist, 51 — Return-to-Work Programs',
    initials: 'MT',
    quote:
      'Most of my patients need to get back to lifting at work. The functional volume — floor-to-waist lifting, laundry basket transfers, pushing and pulling — maps directly to the tasks they actually do. It made my return-to-activity plans much more practical.',
  },
  {
    name: 'Sofía G.',
    role: 'Physiotherapist & Clinic Owner, 42',
    initials: 'SG',
    quote:
      'With three therapists on my team, consistency was our biggest challenge. Now we use the session planner and the home programs as a shared framework. Patients leave with clear written routines and our follow-ups are far better organized.',
  },
]
